export default {
  computed: {
    sasContact() {
      return this.sas.sasContact
    }
  },
  methods: {
    liveSasContact(cle) {
      return { endpoint: "sas-contact", cle: cle, fileId: this.sasContact.id }
    }
  }
}